import { animate, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, ElementRef, HostBinding, Input, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-grow-container',
  templateUrl: './grow-container.component.html',
  styleUrls: ['./grow-container.component.scss'],
  animations: [
    trigger('grow', [
      transition('void <=> *', []),
      transition('* <=> *', [
        style({height: '{{startHeight}}px', overflow: 'hidden'}),
        animate('150ms ease-out'),
      ], {params: {startHeight: 0}}),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GrowContainerComponent {

  @Input() trigger = null;

  @HostBinding('@grow') grow = null;

  constructor(private el: ElementRef) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.trigger) {
      this.grow = {value: this.trigger, params: {startHeight: this.el.nativeElement.clientHeight}};
    }
  }
}
